import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "align-stepper-center" }
const _hoisted_3 = { class: "wrapper-progressBar" }
const _hoisted_4 = {
  class: "progressBar",
  role: "list",
  "aria-label": "progress steps",
  "data-test": "progress-bar"
}
const _hoisted_5 = ["data-test"]

import { Tooltip } from "uiv";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'progress-stepper',
  props: {
    completedStep: {},
    stepsCount: {},
    showTooltip: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const getStepperClass = (index: number): string => {
  if (props.completedStep + 1 === index) return "active";
  if (props.completedStep < index) return "";
  return "completed";
};

const tooltipText = computed<string>(() => {
  return props.showTooltip && props.completedStep + 1 !== props.stepsCount
    ? `Step ${props.completedStep + 2} out of ${props.stepsCount}`
    : "";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_unref(Tooltip), {
          text: tooltipText.value,
          enterable: false
        }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_4, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stepsCount, (index) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: index,
                  class: _normalizeClass(getStepperClass(index - 1)),
                  "data-test": `progress-bar-step-${index}`
                }, null, 10, _hoisted_5))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["text"])
      ])
    ])
  ]))
}
}

})